<template>

    <rkm-form ref="RkmForm">
        <acidente-trabalho-atendimento
            :data="data"
            :title="tituloFormulario()"
            disabled
        />
        <acidente-trabalho-parecer-medico
            v-if="data.model.acidenteTrabalho.parecerMedico"
            :data="data"
            :disabled="disabled"
        />
    </rkm-form>
</template>

<script>
// Components.
import tipoFormularioAcidenteTrabalho from '@/enums/pronto-atendimento/tipoFormularioAcidenteTrabalho'
import AcidenteTrabalhoAtendimento from './Atendimento'
import AcidenteTrabalhoParecerMedico from './ParecerMedico'

export default {
    components: {
        AcidenteTrabalhoAtendimento,
        AcidenteTrabalhoParecerMedico,
    },
    data: () => ({
        enums: {
            tipoFormularioAcidenteTrabalho
        },
    }),
    methods: {
        save() {
            this.$refs.RkmForm.validate().then(response => {
                if (response === true) {

                    const formularioTemCat = parseInt(this.data.model.acidenteTrabalho.tipoFormularioAcidenteTrabalho) != this.enums.tipoFormularioAcidenteTrabalho.RAAT;

                    if (this.data.model.acidenteTrabalho.parecerMedico.agenteId === null) {
                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Ação não permitida',
                            message: 'Agente é obrigatório.',
                        })
                    }
                    else if (this.data.model.acidenteTrabalho.parecerMedico.parteCorpoAtingidaOutras === null && this.data.model.acidenteTrabalho.parecerMedico.partesCorpoAtingidas.length === 0) {
                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Ação não permitida',
                            message: 'É obrigatório informar ao menos uma parte do corpo.',
                        })
                    }
                    else if (this.data.model.acidenteTrabalho.parecerMedico.parteCorpoAtingidaOutras === null && this.data.model.acidenteTrabalho.parecerMedico.partesCorpoAtingidas.length === 0) {
                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Ação não permitida',
                            message: 'É obrigatório informar ao menos uma parte do corpo.',
                        })
                    }
                    else if (this.data.model.acidenteTrabalho.parecerMedico.causasAcidente.length === 0) {
                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Ação não permitida',
                            message: 'É obrigatório informar ao menos uma causa do acidente.',
                        })
                    }
                    else if (this.data.model.acidenteTrabalho.parecerMedico.diagnosticoOutros === null && this.data.model.acidenteTrabalho.parecerMedico.diagnosticos.length === 0) {
                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Ação não permitida',
                            message: 'É obrigatório informar ao menos um diagnóstico.',
                        })
                    }
                    else if(
                        formularioTemCat &&
                        this.data.model.acidenteTrabalho.parecerMedico.pacienteSofreuAcidenteTrabalho === null
                        ) {
                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Ação não permitida',
                            message: 'É obrigatório informar se o paciente sofreu acidente de trabalho.',
                        })
                    }
                    else if(
                        formularioTemCat &&
                        this.data.model.acidenteTrabalho.parecerMedico.pacientePortadorDoencaOcupacional === null
                        ) {
                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Ação não permitida',
                            message: 'É obrigatório informar se o paciente é portador de doença ocupacional.',
                        })
                    }
                    else if(
                        formularioTemCat &&
                        this.data.model.acidenteTrabalho.parecerMedico.pacientePrecisaInternacao === null
                        ) {
                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Ação não permitida',
                            message: 'É obrigatório informar se o paciente precisa de internação.',
                        })
                    }
                    else if(
                        formularioTemCat &&
                        this.data.model.acidenteTrabalho.parecerMedico.diasAfastamento === null
                        ) {
                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Ação não permitida',
                            message: 'É obrigatório informar os dias de afastamento.',
                        })
                    }
                    else if (this.data.model.acidenteTrabalho.parecerMedico.classificacaoInicialId === null) {
                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Ação não permitida',
                            message: 'Classificação inicial é obrigatória.',
                        })
                    }
                    else if (this.data.model.acidenteTrabalho.parecerMedico.afastado === null) {
                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Ação não permitida',
                            message: 'Com afastamento é obrigatório.',
                        })
                    }
                    else {
                        const form = Object.assign({}, this.data.model.acidenteTrabalho.parecerMedico);

                        this.data.model.acidenteTrabalho.parecerMedico = form;

                        this.$emit('saved', this.data.model.acidenteTrabalho.parecerMedico)
                    }
                }
            })
        },
        tituloFormulario() {
            switch (parseInt(this.data.model.acidenteTrabalho.tipoFormularioAcidenteTrabalho)) {
                case this.enums.tipoFormularioAcidenteTrabalho.CAT:
                    return 'CAT'
                case this.enums.tipoFormularioAcidenteTrabalho.RAAT:
                    return 'RAAT'
                default:
                    return 'CAT/RAAT'
            }
        }
    },
    props: {
        data: { type: Object, required: true },
        disabled: { type: Boolean, default: false },
    },
}
</script>